$(document).ready(function () {
	$('[data-hbox-readmore]').each(function () {
		let cheight = $(this).data('hbox-readmore-height') || 250
		let targetEl = $(this)

		targetEl.readmore({
			collapsedHeight: cheight,
			moreLink: `<a href="#" class="hbox-readmore-toggle hbox-readmore-toggle--showmore">
					<div class="hbox-readmore-toggle__content">
						<span class="hbox-readmore-toggle__text">${mL('espandi')}</span>
						<span class="hbox-readmore-toggle__icon material-icons">keyboard_arrow_down</span>
					</div>
				</a>`,
			lessLink: `<a href="#" class="hbox-readmore-toggle hbox-readmore-toggle--showless">
					<div class="hbox-readmore-toggle__content">
						<span class="hbox-readmore-toggle__text">${mL('comprimi')}</span>
						<span class="hbox-readmore-toggle__icon material-icons">keyboard_arrow_up</span>
					</div>
				</a>`,
		})
	})

	function mL(string) {
		const data = {
			espandi: {
				it: 'Mostra tutto',
				en: 'Show all',
				de: 'Zeige alles',
			},
			comprimi: {
				it: 'Mostra meno',
				en: 'Show less',
				de: 'Zeige weniger',
			},
		}

		return data[string][WC.lang.substr(0, 2)]
	}
})
